import CustomerService from "../components/customor_service";
import Footer from "../components/footer";
import Navbar from "../components/navbar";
import Unit from "../components/unit_mbg";

export default function UnitLayout() {
    return (
        <>
        <Navbar/>
        <Unit/>
        <CustomerService/>
        <Footer/>
        </>
    );
}